export default __webpack_public_path__ + "static/media/Jenn 2020 Logo-37.6827d76e.png";